"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_USER_ACCESS_SCOPES = exports.ANONYMOUS_VIEWER = exports.ACCESS_BLOCKED_BY = exports.LOCKED_REASONS = void 0;
/** 权限不足的原因，用于前端展示明确提示（04-UI设计规范 第 9 节） */
exports.LOCKED_REASONS = [
    'LOGIN_REQUIRED',
    'MEMBERSHIP_REQUIRED',
    'SPECIFIC_USERS_ONLY',
    /** 下载被查看权限阻断：下载维度必须明确说明根因是查看未通过（P1-08） */
    'VIEW_ACCESS_REQUIRED',
];
/** 权限被阻断的根因维度 */
exports.ACCESS_BLOCKED_BY = ['VIEW_ACCESS'];
/** 游客上下文 */
exports.ANONYMOUS_VIEWER = {
    isAuthenticated: false,
    userId: null,
    userType: null,
    membershipTier: 'NONE',
    isAdminManagementContext: false,
    agreementAccepted: false,
};
/** 指定用户授权作用域（P0-02：查看白名单与下载白名单互不覆盖） */
exports.CONTENT_USER_ACCESS_SCOPES = ['VIEW', 'DOWNLOAD', 'BOTH'];
//# sourceMappingURL=access.js.map